
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UserDemoIconComponent } from "./user-demo-icon.svg";

export const UserDemoIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UserDemoIconComponent {...props} />;
};
